import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { MESSENGERS_REACT_ICONS_MAP } from '@mssgme/constants';
import DateBreak from './DateBreak';

import styles from './StartConversation.scss';

export default function StartConversation({ className, platform, title, time }) {
    const Icon = MESSENGERS_REACT_ICONS_MAP[platform];

    return (
        <>
            <div className={cn(styles.root, className)}>
                <div className={styles.heading}>
                    <Icon key={platform} className={styles.icon} size={24} color="#8E8E8E" /> {title}
                </div>
            </div>
            <DateBreak time={time} />
        </>
    );
}

StartConversation.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    time: PropTypes.object.isRequired,
    platform: PropTypes.oneOf(['messenger', 'viber', 'telegram', 'vk', 'whatsapp']).isRequired,
};

StartConversation.defaultProps = {
    title: '',
    className: '',
};
